export default "__VITE_ASSET__RVWF4M7W__";